import React from 'react';
import styled from 'styled-components';
import { NavbarPage } from '../Navbar/Navbar';
import { Footer } from '../Footer';
import FAQDoc from './Documentation/InnowaveDocumentation/Faq/FAQDoc';

const TopMargin = styled.div`
  margin-top: 100px;
`;

function FAQPage() {
  return (
    <>
      <NavbarPage />
      <TopMargin>
        <FAQDoc />
      </TopMargin>
      <Footer />
    </>
  );
}

export default FAQPage;
